/**
 * "Report this page" (PR 10c, owner ruling G16): the fixed reasons a visitor
 * picks from on a public page, and the words the admin reports list shows for
 * each. The `value` is what `POST /api/share/{code}/report` stores (keepr-api
 * utils/shareReports.js REASONS — an unknown one is 400 `invalid_reason`); an
 * unknown one in the admin list (a reason added later) reads as itself.
 */
export const REPORT_REASONS = [
	{ value: 'personal_data', label: "It shows someone's personal information" },
	{ value: 'malware', label: 'It has a harmful or suspicious file' },
	{ value: 'phishing', label: "It's a scam or phishing" },
	{ value: 'harassment', label: 'It harasses or threatens someone' },
	{ value: 'illegal', label: "It's illegal" },
	{ value: 'spam', label: "It's spam" },
	{ value: 'other', label: 'Something else' },
];

/** The optional words a visitor may add (the API refuses more). */
export const REPORT_DETAILS_MAX = 500;

const LABELS = new Map(REPORT_REASONS.map(reason => [reason.value, reason.label]));

export const reportReasonLabel = value => LABELS.get(value) || (typeof value === 'string' && value ? value : 'No reason given');
